import { createApp } from 'vue';

import App from 'src/App.vue';
import router from 'src/router';

export const app = createApp(App);

app.use(router);

import { initPrimevue } from 'src/boot/primevue';
initPrimevue(app);

import { createPinia } from 'pinia';
app.use(createPinia());

//SENTRY
import { initSentry } from 'src/boot/sentry';
initSentry(app, router);

//I18N
import { initI18n } from 'src/boot/i18n';
initI18n(app);

// new Design system material icons native support
import 'src/css/material-icons.css';
import 'src/css/app.scss';

import 'animate.css';

// init component library
import { initComponentLibrary } from 'src/boot/componentLibrary';
initComponentLibrary(app);

import 'src/css/tailwind.css';

// QA e2e: kill all animations when localStorage flag is set.
//   Robot:  Execute Javascript  window.localStorage.setItem('disableAnimations','true')
//           Reload Page
// Two layers:
//   - 'no-anim' class drives the global CSS override (src/css/disable-animations.scss).
//   - motion-v animates via JS, not CSS; MotionGlobalConfig.instantAnimations makes its
//     engine snap every animation to its end frame (declarative + imperative animate()),
//     bypassing per-component transitions/springs. It's a shared singleton, so setting
//     it here covers the whole app with no provider/context wiring.
import { MotionGlobalConfig } from 'motion-v';
import 'src/css/disable-animations.scss'; // QA e2e animation kill-switch (see below)
try {
  if (localStorage.getItem('disableAnimationsQA')) {
    document.documentElement.classList.add('no-anim');
    MotionGlobalConfig.instantAnimations = true;
  }
} catch {
  /* storage blocked — boot normally */
}

app.mount('#app');
